// extracted by mini-css-extract-plugin
module.exports = {"large":"1","normal":"1","small":"1","tiny":"1"};